"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _clearModal["default"];
  }
});
var _clearModal = _interopRequireDefault(require("./clearModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }